import React from 'react';
import './newImgStyle.scss';
import InfoIcon from 'assets/icons/info.png';

function NewImgStyle({ imageURL }) {
  return (
    <div className="new-image-container">
      <img className="brand" src={imageURL} alt="MediaImage" />
      <div className="pointer-container">
        <div className="pointer-shadow"></div>

        <div className="pointer">
          <img
            style={{ width: '3px', objectFit: 'contain' }}
            alt="info-icon"
            src={InfoIcon}
          ></img>
        </div>
      </div>
    </div>
  );
}

export default NewImgStyle;
